import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOldPhone"><Path d="M4.5 6.76316V1.5M4.5 3.5H19.5V17.5C19.5 19.7091 17.7091 21.5 15.5 21.5H8.5C6.29086 21.5 4.5 19.7091 4.5 17.5V3.5ZM7.5 6.5H16.5V13.5H7.5V6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconOldPhone;
